// @context TGW-2926 チケット金額欄の入力判定。以前は1文字打つたびに数字以外を 0 に書き換えていたため、
//   Mac の日本語入力で全角「５００」と打つと、変換して半角にする前に 0 に戻り、500円のチケットしか作れなかった。
//   打っている間は文字をそのまま残し、欄を離れた時にここで判定する。全角数字・カンマはよくある打ち方なので受け付ける。

export const PRICE_NOT_NUMBER_ERROR = '金額は数字で入力してください';

export const priceBelowMinError = (min) => `${min}円以上で入力してください`;

// 全角→半角（NFKC）にそろえ、カンマと空白（全角空白も NFKC で半角になる）を取り除く
export const normalizePriceInput = (text) =>
  String(text ?? '')
    .normalize('NFKC')
    .replace(/[,\s]/g, '');

// 0 以上の整数として読めれば数値、空欄や数字以外を含めば null（空欄を 0 とみなさない）
export const parsePriceInput = (text) => {
  const normalized = normalizePriceInput(text);
  return /^\d+$/.test(normalized) ? Number(normalized) : null;
};

export const validatePriceInput = (text, min) => {
  const price = parsePriceInput(text);
  if (price === null) {
    return { ok: false, error: PRICE_NOT_NUMBER_ERROR };
  }
  if (price < min) {
    return { ok: false, error: priceBelowMinError(min) };
  }
  return { ok: true, price };
};
